// tslint:disable:max-line-length

import React from 'react';

export const UtilitySpooler = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M11.5,6C9,6,7,8,7,10.5S9,15,11.5,15s4.5-2,4.5-4.5S14,6,11.5,6z M14.6,11H12h-1V6.9h1V10h2.5v1H14.6z" />
      <polygon points="12,1 4,1 4,5 11.5,5 12,5" />
      <path d="M8.3,6H3V3H2v3H0.2C0.1,6,0,6.1,0,6.2v6.5c0,0.1,0.1,0.2,0.2,0.2H3v-3h3C6.2,8.3,7.1,6.9,8.3,6z" />
      <path d="M14,3h-1v2.2c0.3,0.1,0.7,0.2,1,0.4V3z" />
      <path d="M6,11H4v4h4.3C7.1,14.1,6.2,12.7,6,11z" />
    </svg>
  );
};
